import { COUNTRIES } from '@/libs/constants'
import { Utils } from '@/libs/Utils'
import React from 'react'
import { Col, Form, InputGroup, Row } from "react-bootstrap"
const Telephone: React.FC<{ locale: string }> = ({ locale }) => {

    const t = new Utils(locale).Translation
    const [country, setCountry] = React.useState<string>("VN")
    return (
        <>
            <Row className="mb-3">
                <Form.Group as={Col} md={6} xs={4}>
                    <Form.Label>{t("form.phone")} <span className="text-danger">*</span></Form.Label>
                    <Form.Select value={country}
                        onChange={(event: HTMLSelectElement | any) => {
                            setCountry(event?.target?.value as string)
                        }}
                    >
                        {COUNTRIES.map((c: any, index: number) => {
                            return (
                                <option value={c?.value} key={index}>{c?.label} </option>
                            )
                        })}
                    </Form.Select>
                </Form.Group>
                <Form.Group as={Col} md={6} xs={8}>
                    <InputGroup style={{ marginTop: 30 }}>
                        <InputGroup.Text id="phone">{COUNTRIES.find((c: any) => c?.value === country)?.phone}</InputGroup.Text>
                        <Form.Control required pattern="^\s*(?:\+?(\d{1,3}))?[-. (]*(\d{3})[-. )]*(\d{3})[-. ]*(\d{4})(?: *x(\d+))?\s*$" type="tel" name="phone"
                        />
                        <Form.Control.Feedback type="invalid">[{t("form.phone")}]
                            {t("required.message")}
                        </Form.Control.Feedback>
                    </InputGroup>
                </Form.Group>
            </Row>
        </>
    )
}

export default Telephone